export default "__VITE_ASSET__C9XEH9Yc__"